import type { QuoteInfo } from 'apiConnector/scheduledRun/model';
import type {
  EditableFooterDispatchProps,
  EditableFooterStateProps,
} from 'components/shared/ScheduledRun/Blotter/panel/Shared/EditableFooter';
import {
  EditableFooter,
  editableFooterMapDispatchToProps,
  editableFooterMapStateToProps,
} from 'components/shared/ScheduledRun/Blotter/panel/Shared/EditableFooter';
import { differenceBy } from 'lodash-es';
import { connect, type MapStateToProps } from 'react-redux';
import {
  EDITABLE_SCHEDULED_RUN_BLOTTER_ID,
  getEditableScheduledRun,
  getEditableScheduledRunQuotes,
} from 'state/blotters/scheduledQuotes';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

const quoteIdSelector = (q: QuoteInfo) => q.quoteId;
const mapStateToProps: MapStateToProps<EditableFooterStateProps, {}, AppState> = state => {
  const run = getEditableScheduledRun(state);
  const quotes = getEditableScheduledRunQuotes(state);
  return {
    ...editableFooterMapStateToProps(state),
    isEditing: getEditableScheduledRun(state).type === 'updateQuotes',
    hasChanged:
      differenceBy(run.quotes, quotes, quoteIdSelector).length > 0 ||
      differenceBy(quotes, run.quotes, quoteIdSelector).length > 0,
  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch): EditableFooterDispatchProps => ({
  ...editableFooterMapDispatchToProps(dispatch),
  onEditClicked() {
    dispatch(scheduledRunActions.setOperation(EDITABLE_SCHEDULED_RUN_BLOTTER_ID, 'updateQuotes'));
  },
  onConfirmUpdate() {
    dispatch(scheduledRunActions.updateQuotesRequested(EDITABLE_SCHEDULED_RUN_BLOTTER_ID));
    dispatch(scheduledRunActions.setConfirmBanner(EDITABLE_SCHEDULED_RUN_BLOTTER_ID, 'update'));
  },
});

const ConnectedQuotesFooter = connect(mapStateToProps, mapDispatchToProps)(EditableFooter);
export function QuotesFooter() {
  return (
    <ConnectedQuotesFooter
      editBtnLabel="scheduledRun.quotes.manage"
      editBtnIcn="sort"
      confirmMessageLabel="scheduledRun.quotes.confirm"
      errorLabel="scheduledRun.quotes.update.error"
      analyticAction="Manage quotes"
    />
  );
}
